var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIconLightMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.53,
    height: 24.53,
    viewBox: "0 0 24.53 24.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 125",
    transform: "translate(.707 .707)",
    style: {
      fill: "none",
      stroke: "#e9e7e1",
      strokeWidth: 2
    },
    d: "M23.116 0 0 23.116"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 126",
    transform: "translate(.707 .707)",
    style: {
      fill: "none",
      stroke: "#e9e7e1",
      strokeWidth: 2
    },
    d: "M23.116 23.116 0 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconLightMobile);
export default __webpack_public_path__ + "static/media/close-icon-light-mobile.bf8eeff8c90164244cdd55e7d9ccff0c.svg";
export { ForwardRef as ReactComponent };